import React, { useEffect, useState } from "react";
import "./Inicio.css";

import { Chart } from "primereact/chart";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    faUser,
    faBox,
    faDollarSign
} from "@fortawesome/free-solid-svg-icons";

export default function Inicio() {

    const [chartDataProductos, setChartDataProductos] = useState({});
    const [chartDataGanancias, setChartDataGanancias] = useState({});

    const [chartOptionsProductos, setChartOptionsProductos] = useState({});
    const [chartOptionsGanancias, setChartOptionsGanancias] = useState({});

    useEffect(() => {

        cargarGraficoProductos();

        cargarGraficoGanancias();

    }, []);

    // KPIs DEMO
    const clienteFrecuente = "Eventos Corporativos SAC";

    const productoDestacado = "Silla Tiffany";

    const gananciaMes = "S/ 18,540";

    const cargarGraficoProductos = () => {

        const labels = [
            "Silla Tiffany",
            "Mesa Redonda",
            "Silla Crossback",
            "Banco Industrial",
            "Toldo 4x4"
        ];

        const alquileres = [
            320,
            180,
            140,
            95,
            75
        ];

        setChartDataProductos({
            labels,
            datasets: [
                {
                    data: alquileres,
                    backgroundColor: [
                        "#00B894",
                        "#00CEC9",
                        "#0984E3",
                        "#6C5CE7",
                        "#FD79A8"
                    ]
                }
            ]
        });

        setChartOptionsProductos({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: "right"
                }
            }
        });
    };

    const cargarGraficoGanancias = () => {

        const meses = [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun"
        ];

        const ingresos = [
            8200,
            9100,
            11000,
            14500,
            13200,
            18540
        ];

        setChartDataGanancias({
            labels: meses,
            datasets: [
                {
                    label: "Ingresos por alquileres",
                    data: ingresos,
                    fill: true,
                    tension: 0.4,
                    borderColor: "#00B894",
                    backgroundColor: "rgba(0,184,148,.12)",
                    pointRadius: 5,
                    pointBackgroundColor: "#00B894"
                }
            ]
        });

        setChartOptionsGanancias({
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        callback: (value) =>
                            "S/ " + value.toLocaleString()
                    }
                }
            }
        });
    };

    return (

        <div className="inicioPage">

            {/* KPI CARDS */}

            <div className="CardsCantidad">

                <div className="cardCantidad">

                    <FontAwesomeIcon
                        icon={faUser}
                        className="icons"
                    />

                    <div className="deColumn">

                        <h2>Cliente Frecuente</h2>

                        <h3>{clienteFrecuente}</h3>

                    </div>

                </div>

                <div className="cardCantidad">

                    <FontAwesomeIcon
                        icon={faBox}
                        className="icons"
                    />

                    <div className="deColumn">

                        <h2>Mobiliario Más Alquilado</h2>

                        <h3>{productoDestacado}</h3>

                    </div>

                </div>

                <div className="cardCantidad">

                    <FontAwesomeIcon
                        icon={faDollarSign}
                        className="icons"
                    />

                    <div className="deColumn">

                        <h2>Ingresos del Mes</h2>

                        <h3>{gananciaMes}</h3>

                    </div>

                </div>

            </div>

            {/* PRODUCTOS MÁS ALQUILADOS */}

            <div className="graficoCard">

                <h3>Mobiliario Más Alquilado</h3>

                <div className="graficoWrap">

                    <Chart
                        type="polarArea"
                        data={chartDataProductos}
                        options={chartOptionsProductos}
                        style={{
                            height: "260px"
                        }}
                    />

                </div>

            </div>

            {/* INGRESOS */}

            <div className="graficoCard">

                <h3>Ingresos por Alquileres</h3>

                <div className="graficoWrap">

                    <Chart
                        type="line"
                        data={chartDataGanancias}
                        options={chartOptionsGanancias}
                        style={{
                            height: "260px"
                        }}
                    />

                </div>

            </div>

        </div>

    );
}